import { render, staticRenderFns } from "./UserScientificDegreeAdd.vue?vue&type=template&id=1a24dd32&"
import script from "./UserScientificDegreeAdd.vue?vue&type=script&lang=js&"
export * from "./UserScientificDegreeAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports